import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const ENV = import.meta.env.VITE_SENTRY_ENV as string | undefined
const RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string | undefined

const PII_PATTERNS = [
  /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i,
  /01[016789][- ]?\d{3,4}[- ]?\d{4}/,
]

const PII_REDACTED = '[REDACTED]'

// 단위 테스트용으로 export — 보안 핵심 로직이라 직접 검증 가치 큼.
export function containsPII(value: unknown): boolean {
  if (typeof value !== 'string') return false
  return PII_PATTERNS.some((pattern) => pattern.test(value))
}

export function scrubRecord(
  record: Record<string, unknown> | undefined
): Record<string, unknown> | undefined {
  if (!record) return record
  const cleaned: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(record)) {
    cleaned[key] = containsPII(value) ? PII_REDACTED : value
  }
  return cleaned
}

export function initSentry(): void {
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    environment: ENV ?? 'dev',
    release: RELEASE,
    sampleRate: 1.0,
    tracesSampleRate: 0,
    ignoreErrors: [
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      /Loading chunk \d+ failed/,
    ],
    beforeSend(event) {
      if (event.extra) {
        event.extra = scrubRecord(event.extra)
      }
      if (event.contexts) {
        for (const [key, ctx] of Object.entries(event.contexts)) {
          if (ctx && typeof ctx === 'object') {
            event.contexts[key] = scrubRecord(ctx as Record<string, unknown>)
          }
        }
      }
      return event
    },
  })
}

export function setSentryUser(userId: string | null): void {
  if (!DSN) return
  Sentry.setUser(userId ? { id: userId } : null)
}

export { Sentry }
